import { API, api } from "@/lib/api";

export const mediaUrl = (id) => `${API}/media/${id}?auth=${localStorage.getItem("access_token") || ""}`;

export const uploadAttachment = (cid, file, caption = "") => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("caption", caption);
  return api.post(`/conversations/${cid}/attachments`, fd);
};

export const fileSize = (b = 0) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);
